import { useState } from 'react';
import useClickOutside from '../../../../useClickOutside';

export const ColumnSuppliers = (translate, warning, handleEdit, langLocal,setOpenMaterial) => {
    const [options, setOptions] = useState(false)
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['first_name']} {''} {row['last_name']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('email')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['email']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('phone')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['phone_number']}</span>
            )
        },

        {
            name: <span className="color_spann">{translate('role')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['role']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row, index) => (
                <div  >
                    {/*<i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>*/}
                    <i className='fa fa-ellipsis-v icon_edit' onClick={() => { setOptions(!options); setRowId(index) }}  ></i>
                    {
                        options && index === row_id && (
                            <div className='div-actions shadow_main' >
                                <span onClick={(e) => handleEdit(e, row)} >Edit</span>
                                <span onClick={() => warning(row)} >Delete</span>
                                <span onClick={()=> setOpenMaterial(true)} >Materials</span>
                            </div>
                        )
                    }
                </div>
            )
        }
    ]
    return {
        columns
    }
}